// Export complet des données d'une société (réversibilité : conditions générales art. 14, accord de sous-traitance art. 16,
// règlement (UE) 2023/2854 « Data Act »). Constantes partagées par le serveur et l'interface.

/** Durée pendant laquelle l'archive reste téléchargeable, puis elle est effacée du stockage. */
export const JOURS_CONSERVATION_EXPORT = 7;

/** Longueur minimale de la phrase de passe qui chiffre les secrets d'installation joints à l'export. */
export const PHRASE_SECRETS_MIN = 12;

export type StatutExport = 'en_file' | 'en_cours' | 'pret' | 'echec' | 'annule' | 'expire';

export const LIBELLES_STATUT_EXPORT: Record<StatutExport, string> = {
  en_file: 'En attente',
  en_cours: 'En préparation',
  pret: 'Prêt à télécharger',
  echec: 'En échec',
  annule: 'Annulé',
  expire: 'Effacé',
};

/** Format de l'archive (manifeste) : à incrémenter si la structure de l'archive change. */
export const FORMAT_EXPORT = { nom: 'trame-export-complet', version: 1 } as const;
